import { useCallback, useEffect, useState } from "react";

// Shared expand/collapse state for a side-panel Drawer that offers a "view
// full screen" toggle — pair with `panelDrawerSx` in
// services/constants/designTokens.js on the Drawer's own `sx` prop. First
// introduced for Users' Create User panel; any other Drawer-based panel can
// adopt the same toggle by calling this hook with its own `open` state
// rather than re-implementing the width/animation logic per screen.
//
// Always resets to collapsed when the panel closes, so a panel never
// silently reopens full-screen from a stale expand click on its next open.
export const useExpandablePanel = (open) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!open) {
      setExpanded(false);
    }
  }, [open]);

  const toggleExpanded = useCallback(() => setExpanded((prev) => !prev), []);

  return { expanded, toggleExpanded };
};
